export default __webpack_public_path__ + "static/media/userm-5.8e4d9ebe.jpg";